
// JavaScript thinks a lot of things are numbers that our codebase does not consider numbers
// This is a one-stop-shop for determining if a number is usable in our codebase
export const isValidNumber = (num: Nullable<number> | undefined): boolean => {
    return typeof num === 'number' && !Number.isNaN(num) && num !== -Infinity && num !== Infinity;
};

export const constrainToRange = (num: number, min: number = 0, max: number = 100): number => {
    return Math.max(Math.min(max, num), min);
};

export const determinePercentageIntoRange = (payNum: number, maxNum: number, minNum: number = 0): number => {
    const totalRange = maxNum - minNum;
    const differenceFromMin = payNum - minNum;
    return Math.round((differenceFromMin / totalRange) * 1000) / 10;
};